import { makeStyles } from "@material-ui/core";

export const css = makeStyles(() => ({
    grid_icons: {
        display: "flex",
    },
}));
